export const THUMB_DELAY_DEFAULT = 20
export const THUMB_DELAY_MAX = 65535
export const THUMB_MARGIN_MAX = 2000
export const THUMB_ROTATION_OPTIONS = [0, 90, 180, 270]